// extracted by mini-css-extract-plugin
module.exports = {"container":"_locale__container__QQwte"};